module.exports = __webpack_public_path__ + "static/img/img_ksfr.43346168.png";